import { selectChangeMessageForTeaserImportance } from '@UI/aside/asideTeaserImportance/asideTeaserImportanceLabel/asideTeaserImportanceSelectors';
import { ContentType, type WebTemplateHref } from '@generalTypes/apiTypes';
import { loadWebConfigurations } from '@newStore/documentApi/documentApiState';
import {
  selectChangeMessageForLinkedContent,
  selectTeaserNode,
} from '@newStore/documentUI/transformContent/teaserSelectors';
// import { teasersDeleteValidationCmd } from '../../../reduxLoop/commands/documentListCommands';
import { getAllOfResource } from '@newStore/externalData/externalDataState';
import { pathMap } from '@newStore/externalData/externalDataTypes';
import { referenceFrames } from '@newStore/referenceFrames/referenceFrames';
import { loadReferenceFrame } from '@newStore/referenceFrames/referenceFramesState';
import { selectValidateTeaserAudienceParentIntersectionNotEmpty } from '@newStore/validation/validationRules/audienceIntersectionRules';
import { selectCurriculumThemesValidation } from '@newStore/validation/validationRules/curriculumThemesConsistencyValidation';
import { selectIsValidReferenceFromTeaser } from '@newStore/validation/validationRules/externalLinkValidationRules';
import { selectCallToActionTitleValidation } from '@newStore/validation/validationRules/teaserCallToActionValidationRules';
import { selectValidateTeaserMatchesSection } from '@newStore/validation/validationRules/teaserMatchesSection';
import {
  type BuildingBlockNodeConfig,
  RequiredType,
  type RootNodeConfig,
} from '@nodeTypeConfig/configTypes';
import { authorsComponent } from '@nodeTypeConfig/helpers/editComponents/authorsComponent';
import { curriculumSelectorComponent } from '@nodeTypeConfig/helpers/editComponents/curriculumSelector';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { proThemesComponent } from '@nodeTypeConfig/helpers/editComponents/proDocumentStandardComponents';
import { proNewsletterAudienceTab } from '@nodeTypeConfig/helpers/editComponents/proNewsletterAudienceTab';
import { proThumbnailComponent } from '@nodeTypeConfig/helpers/editComponents/proThumbnailComponent';
import { publishComponent } from '@nodeTypeConfig/helpers/editComponents/publishComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { asideWebBasicConfiguration } from '@nodeTypeConfig/helpers/editComponents/webConfigComponents';
import { loadNamedSetsAction } from '@store/actions/documentActions';
import { webSitesProHref } from '@store/api/apiRoutes';
import { teasersDeleteValidationCmd } from '@store/commands/documentListCommands';
import { settings } from '../../../settings';

export const teaserImportanceTranslations = {
  LOW: 'Niet opnemen in nieuwsbrief',
  MEDIUM: 'Gewone teaser',
  HIGH: 'Prioritaire teaser',
};

const TEASER: RootNodeConfig & BuildingBlockNodeConfig = {
  nodeSelector: selectTeaserNode,
  deleteFromListValidations: [teasersDeleteValidationCmd],
  validationRules: [
    selectValidateTeaserMatchesSection,
    selectCurriculumThemesValidation,
    selectValidateTeaserAudienceParentIntersectionNotEmpty,
  ],
  information: {
    definiteArticle: false,
    single: 'PRO.-teaser',
    plural: 'PRO.-teasers',
    ribonIcon: require('../../../../../img/buildingBlocks/TEASER.svg'),
    category: 'PRO',
  },
  websiteHref: webSitesProHref,
  webconfiguration: {
    type: 'NEWS_ITEM_AND_TEASER_FALLBACK',
    website: {
      href: webSitesProHref,
    },
    template: {
      href: '/web/templates/d153f5d5-78b3-4de7-a231-281da633a8bb' as WebTemplateHref,
    },
  },
  onLoadActions: [
    loadWebConfigurations(),
    loadReferenceFrame({ referenceFrame: referenceFrames.pro }),
    getAllOfResource({ resource: pathMap.namedSets, refresh: false }),
    /**
     * the ACTION_TYPES.PATCH_THEMES action still needs the doelgroepen namedset to be present
     * in the old reducer.
     * Once the PATCH_xxx actions are removed, this action can be removed as well.
     */
    loadNamedSetsAction('doelgroepen'),
  ],
  createModal: {
    authors: {
      addUser: true,
      required: true,
    },
  },
  tocTypes: [],
  buildingBlocks: [],
  edit: [
    {
      ...titleComponent,
      options: {
        hideTermButton: true,
      },
    },
    {
      ...descriptionComponent,
      label: 'Teaser',
      required: RequiredType.ERROR,
      maxLength: 400,
      options: {
        hideTermButton: true,
      },
    },
    {
      ...authorsComponent,
      required: RequiredType.ERROR,
    },
    publishComponent,
    proThemesComponent,
    curriculumSelectorComponent,
    {
      property: 'importance',
      label: 'Belangrijkheid',
      component: 'teaserImportance',
      reactComponent: 'AsideTeaserImportance',
      asideChangeMessageSelector: selectChangeMessageForTeaserImportance,
    },
    proThumbnailComponent,
    {
      component: 'teaserLinkedContent',
      reactComponent: 'AsideTeaserLinkedContent',
      asideChangeMessageSelector: selectChangeMessageForLinkedContent,
      label: 'Linkt naar',
      validations: [selectIsValidReferenceFromTeaser, selectCallToActionTitleValidation],
      hiddenChildren: {
        containerType: ContentType.TEASER,
        items: [
          {
            type: ContentType.REFERENCE,
            label: 'link',
          },
        ],
      },
    },
  ],
  audienceTab: proNewsletterAudienceTab,
  webTab: asideWebBasicConfiguration,
  onNewNodeDropped: {
    openAside: false,
  },
  isCreatable: true,
  isSearchable: true,
  isCollapsible: false,
  isImportable: false,
  allowSuggestions: false,
  // customRender: true,
  websiteEdition: [
    {
      domain: settings.domains.pro,
    },
  ],
  confirmDelete: true,
  // customConfirmDeleteMessage: () => '<li>Ben je zeker dat je dit wil verwijderen?</li>',
  hideChildrenInDocument: true,
  customEditorOptions: {
    showMarkerButton: false,
    hideTermButton: true,
  },
};

export default TEASER;
